import moment from "moment"
import Image from "next/image"
import Link from "next/link"
import React from "react"

import CustomImage from "@components/elements/CustomImage"
import AuthLayout from "@components/layouts/auth"
import useAuth from "@hooks/useAuth"
import BookingSwLogo from "@icons/BookingSwLogo"
import CustomerLoginAuthPlaceholder from "@icons/CustomerLoginAuthPlaceholder"
import CustomerLoginAuthPlaceholderSubImage from "@icons/CustomerLoginAuthPlaceholders"
import Background from "@public/svg/background.svg"

import CustomerLoginForm from "./CustomerLoginForm"

const CustomerLoginPage = () => {
  const { publicDomainDetails } = useAuth() ?? {}

  return (
    <AuthLayout leftArea={<CustomerLoginInfoSection />}>
      <div className={"relative w-full m-auto flex flex-col items-center justify-center h-full"}>
        <div className={"w-full"}>
          {publicDomainDetails?.logo ? (
            <CustomImage
              src={publicDomainDetails?.logo}
              className={"w-auto max-h-12"}
              height={40}
              width={80}
              fill={false}
            />
          ) : (
            <Link href={"/"}>
              <BookingSwLogo />
            </Link>
          )}
          <h5 className={"pt-2 text24Regular text-neutral-1000"}>Welcome to</h5>
          <h4 className={"text32Semibold text-primary-1000"}>{publicDomainDetails.company}</h4>
          <h6 className={"pt-2 text16Regular text-neutral-600"}>Sign in to your account.</h6>
          <CustomerLoginForm className={"pt-10 pb-5"} />
        </div>
        <div
          className={
            "flex flex-row items-center justify-between w-full gap-2 flex-wrap absolute bottom-0 left-1/2 -translate-x-1/2"
          }
        >
          {publicDomainDetails?.company ? (
            <p className={"text12Regular text-neutral-800"}>
              {moment().format("YYYY")} © {publicDomainDetails.company}. All Rights Reserved.
            </p>
          ) : null}
          <p className={"text12Regular text-neutral-800"}>
            Powered by{" "}
            <Link
              className={"text12Regular text-primary-600"}
              href={"https://www.smartrezbooking.com/"}
              target={"_blank"}
            >
              smartrezbooking
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  )
}

export const CustomerLoginInfoSection = () => {
  const { publicDomainDetails } = useAuth() ?? {}
  return (
    <div className={"flex flex-col justify-center items-center h-full"}>
      {publicDomainDetails?.member_login_bg_image ? (
        <Image
          src={publicDomainDetails.member_login_bg_image}
          className={"mx-auto"}
          fill
          alt={"Company Banner"}
          objectFit={"cover"}
        />
      ) : (
        <div>
          <div>
            <Background
              className={"object-cover overflow-hidden opacity-30 mix-blend-soft-light"}
            />
          </div>

          <div className={"absolute right-0 top-1/2 -translate-y-full"}>
            <div className={"w-[485px]"}>
              <CustomerLoginAuthPlaceholder />
              <div className={"relative"}>
                <CustomerLoginAuthPlaceholderSubImage
                  className={
                    "absolute bottom-[-80px] left-[-7%] rounded-[10px] lg:left-[-5%]  xl:left-[-17%]"
                  }
                />
              </div>
            </div>
          </div>

          <div className={"absolute top-[calc(50%+95px)] right-[17%] text-center"}>
            <h5 className={"text-white text32Semibold"}>{publicDomainDetails?.company ?? ""}</h5>
            <h6 className={"text-white text24Semibold"}>Manage your orders & bookings.</h6>
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomerLoginPage
